/**
 * Category Switcher
 * Handles horizontal scrolling navigation with arrow controls
 */

(function() {
  'use strict';

  class CategorySwitcher {
    constructor(element) {
      this.element = element;
      this.scrollContainer = element.querySelector('[data-scroll]');
      this.prevArrow = element.querySelector('[data-arrow-prev]');
      this.nextArrow = element.querySelector('[data-arrow-next]');
      
      if (!this.scrollContainer) return;
      
      this.scrollAmount = 440; // Approximate width of 3 tiles + gaps
      
      this.init();
    }

    init() {
      this.bindEvents();
      this.updateArrowStates();
      this.setActiveState();
    }

    bindEvents() {
      // Arrow click handlers (only active on desktop >= 1024px)
      if (this.prevArrow) {
        this.prevArrow.addEventListener('click', () => {
          if (this.isDesktop()) {
            this.scrollPrev();
          }
        });
      }
      
      if (this.nextArrow) {
        this.nextArrow.addEventListener('click', () => {
          if (this.isDesktop()) {
            this.scrollNext();
          }
        });
      }

      // Update arrow states on scroll
      this.scrollContainer.addEventListener('scroll', () => {
        this.updateArrowStates();
      });

      // Update arrow states on resize
      window.addEventListener('resize', () => {
        this.updateArrowStates();
      });
    }

    isDesktop() {
      return window.innerWidth >= 1280;
    }

    scrollPrev() {
      this.scrollContainer.scrollBy({
        left: -this.scrollAmount,
        behavior: 'smooth'
      });
    }

    scrollNext() {
      this.scrollContainer.scrollBy({
        left: this.scrollAmount,
        behavior: 'smooth'
      });
    }

    updateArrowStates() {
      if (!this.prevArrow || !this.nextArrow) return;

      // Only manage arrow states on desktop
      if (!this.isDesktop()) return;

      const scrollLeft = this.scrollContainer.scrollLeft;
      const scrollWidth = this.scrollContainer.scrollWidth;
      const clientWidth = this.scrollContainer.clientWidth;
      const maxScroll = scrollWidth - clientWidth;

      // Disable prev arrow if at start
      if (scrollLeft <= 1) {
        this.prevArrow.disabled = true;
      } else {
        this.prevArrow.disabled = false;
      }

      // Disable next arrow if at end
      if (scrollLeft >= maxScroll - 1) {
        this.nextArrow.disabled = true;
      } else {
        this.nextArrow.disabled = false;
      }
    }

    setActiveState() {
      const currentPath = window.location.pathname.replace(/\/$/, '');
      const tiles = this.scrollContainer.querySelectorAll('.category-switcher__tile');
      let activeTile = null;

      tiles.forEach(tile => {
  const tileUrl = new URL(tile.href, window.location.origin);
  const tilePath = tileUrl.pathname.replace(/\/$/, '');
  const tileTitle = tile.textContent.trim().toLowerCase();

  tile.classList.remove('category-switcher__tile--active');

  // Normal active state
  if (tilePath === currentPath) {
    tile.classList.add('category-switcher__tile--active');
    activeTile = tile;
  }

  /// Force Replica Cloud tile active on Replica Cloud page
if (
  currentPath === '/collections/replica-cloud-modular' &&
  tileTitle.includes('replica cloud')
) {
  tile.classList.add('category-switcher__tile--active');
  activeTile = tile;
}

// Force Valletta tile active on Valletta page
if (
  currentPath === '/collections/the-valletta-modular' &&
  tileTitle.includes('valletta')
) {
  tile.classList.add('category-switcher__tile--active');
  activeTile = tile;
}

});
      
      // Scroll active tile into view
      if (activeTile) {
        this.scrollToTile(activeTile);
      }
    }

    scrollToTile(tile) {
      const containerRect = this.scrollContainer.getBoundingClientRect();
      const tileRect = tile.getBoundingClientRect();
      
      // Calculate the tile's position relative to the scroll container
      const tileLeft = tile.offsetLeft;
      const tileWidth = tile.offsetWidth;
      const containerWidth = this.scrollContainer.clientWidth;
      const scrollLeft = this.scrollContainer.scrollLeft;
      
      // Calculate center position
      const targetScroll = tileLeft - (containerWidth / 2) + (tileWidth / 2);
      
      // Scroll to center the active tile
      this.scrollContainer.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }
  }

  // Initialize all category switchers on the page
  function initCategorySwitchers() {
    const switchers = document.querySelectorAll('[data-category-switcher]');
    switchers.forEach(switcher => {
      new CategorySwitcher(switcher);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategorySwitchers);
  } else {
    initCategorySwitchers();
  }

  // Reinitialize on Shopify section load (theme editor support)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const switcher = event.target.querySelector('[data-category-switcher]');
      if (switcher) {
        new CategorySwitcher(switcher);
      }
    });
  }
})();
